// extracted by mini-css-extract-plugin
export default {"pdf_wrapper":"PdfDisplayTab_pdf_wrapper__hINYu"};